import React, { FC, useState } from 'react'
import DateCalendarModule from './DateCalendarModule'
import { nowDate } from '../../../utils/date'

interface Props {
  initialDate: string | null
  isNotSet: boolean
  changeCallback: (date: string | null) => void
  future?: boolean
  disabled: boolean
  wrapperClass?: string
  popupDisplayType?: 'css' | 'bottom'
}

const NullableDateCalendarModule: FC<Props> = React.memo((props) => {
  const {
    initialDate,
    isNotSet,
    changeCallback,
    future,
    disabled,
    wrapperClass,
    popupDisplayType,
  } = props

  const [basis, setBasis] = useState<string>(initialDate || nowDate('YYYY-MM-DD'))

  return (
    <DateCalendarModule
      date={basis}
      changeCallback={(value) => {
        setBasis(value)
        changeCallback(value)
      }}
      notSetCallback={() => changeCallback(null)}
      displayLabelOverride={isNotSet ? '指定なし' : undefined}
      omit
      future={future}
      disabled={disabled}
      wrapperClass={wrapperClass}
      popupDisplayType={popupDisplayType}
    />
  )
})

NullableDateCalendarModule.defaultProps = {
  future: false,
  wrapperClass: undefined,
}

export default NullableDateCalendarModule
